<template>
  <!--  v-if is in case the form async fetch hasn't been received yet-->
  <loading :loading="!Boolean(handler.form)">
    <template #loading>
      <collapsible-section
        :control-name="dropdownControlId"
        :id="dropdownControlId"
        :is-open="false"
        disabled
        class="collapse-item"
      >
        <template #section-header>
          <xpinner />
        </template>
      </collapsible-section>
    </template>
    <template #loaded>
      <form-field-data
        :handler="handler"
        :q="q"
        :parent-tree-context="computedChildTreeContext"
        @select="select"
      >
        <template #before-workflow-steps>
          <section-fields
            v-if="handler.usersOnly"
            :q="q"
            :handler="handler"
            :section="handler.formUserSection()"
            icon-glyph="member"
            @select="select"
            :select-additional-parameters="[handler.formUserSection().type]"
          />
        </template>

        <template #after-workflow-steps>
          <template
            v-if="!handler.usersOnly"
          >
            <!--        TODO: Alex: Process Flow: Uncomment once payment data is functional when running a process flow -->
            <!--        <form-payment-step-data-->
            <!--          :handler="handler"-->
            <!--          :q="q"-->
            <!--          @select="select"-->
            <!--          :parent-tree-context="computedChildTreeContext"-->
            <!--        />-->
            <form-submitter-data
              :handler="handler"
              :q="q"
              :level="1"
              @select="select"
              :parent-tree-context="computedChildTreeContext"
            />
          </template>
        </template>
      </form-field-data>
    </template>
  </loading>
</template>

<script lang="ts">
  import Vue from 'vue'
  import handlerComponentMixin from '~/components/dynamicFieldsTrees/mixins/handlerComponentsMixin'
  import FieldItem from '~/components/dynamicFieldsTrees/handlerComponents/common/field-item.vue'
  import FormFieldData from '~/components/dynamicFieldsTrees/handlerComponents/form-field-data.vue'
  // TODO: Alex: Process Flow: Uncomment once payment data is functional when running a process flow
  // import FormPaymentStepData from '~/components/dynamicFieldsTrees/handlerComponents/form-payment-step-data.vue'
  import FormSubmitterData from '~/components/dynamicFieldsTrees/handlerComponents/form-submitter-data.vue'
  import {IDynamicTreeContext, IFormDataSection} from "~/interfaces/dynamicFieldsInterfaces"
  import handlerTreeContextMixin from '~/components/dynamicFieldsTrees/mixins/handlerTreeContextMixin'
  import {ProcessFlowFormDynamicFieldsHandler} from '~/models/dynamicFields/handlers/processFlows/processFlowFormDynamicFieldsHandler'
  import CollapsibleSection from '~/components/dynamicFieldsTrees/handlerComponents/common/collapsible-section.vue'
  import SectionFields from '~/components/dynamicFieldsTrees/handlerComponents/common/section-fields.vue'

  export default Vue.extend({
    mixins: [
      handlerComponentMixin,
      handlerTreeContextMixin
    ],
    components: {
      FieldItem,
      FormFieldData,
      // TODO: Alex: Process Flow: Uncomment once payment data is functional when running a process flow
      // FormPaymentStepData,
      FormSubmitterData,
      CollapsibleSection,
      SectionFields,
    },
    props: {
      handler: {
        type: Object as () => ProcessFlowFormDynamicFieldsHandler,
        required: true,
      },
    },
    computed: {
      formDataSection(): IFormDataSection {
        return this.handler.formDataSection(this.lowerQ);
      },
      treeContext(): Partial<IDynamicTreeContext> {
        return {
          parent: this.handler.form,
          isTopLevelCollectionAssigned: this.handler.isTopLevelCollection(this.handler.form),
        }
      }
    },
  });
</script>